import { useCallback } from 'react';

import useLoginMutation from '@zego/mutations/useLoginMutation';
import { useTracking } from '@zego/tracking';

export default function useLoginForm(inputFn, eventName) {
  const { trackEvent, identifyUser } = useTracking();
  const { call } = useLoginMutation({});

  return useCallback(
    (values, onSuccess, onError) => {
      if (eventName) {
        trackEvent(eventName);
      }
      const data = {
        ...inputFn(values),
      };
      call({ variables: data }, (error, data) => {
        if (error) console.error(error);

        const typename = data?.authenticateUser.__typename;
        if (typename === 'AuthenticateUserInvalidInput') {
          onError(data.authenticateUser.fieldErrors ?? undefined);
          return;
        }

        if (typename === 'AuthenticateUserSuccess') {
          const { customerNumber } = data.authenticateUser.viewer.currentUser;
          if (customerNumber) identifyUser(customerNumber);

          onSuccess(data.authenticateUser);
        }
      });
    },
    [call, eventName, inputFn, trackEvent, identifyUser],
  );
}
